import { useCallback } from "react"
import { ConnectionHandler } from "react-relay"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { chDeleteRecommendedMedicationMutation } from "@/modules/patients/detail/recommended-medications/ch/__generated__/chDeleteRecommendedMedicationMutation.graphql"
import { chDeleteRecommendedMedicationMutation as chDeleteRecommendedMedication } from "@/modules/patients/detail/recommended-medications/ch/chDeleteRecommendedMedicationMutation"
import { deDeleteRecommendedMedicationMutation } from "@/modules/patients/detail/recommended-medications/de/__generated__/deDeleteRecommendedMedicationMutation.graphql"
import { deDeleteRecommendedMedicationMutation as deDeleteRecommendedMedication } from "@/modules/patients/detail/recommended-medications/de/deDeleteRecommendedMedicationMutation"
import { Country } from "@/types/__generated__/union-types"

type MutationParams = {
  id: string
  progressNoteId: string
  onCompleted?: () => void
  onError?: (error: Error | string | undefined) => void
}

export const useDeleteRecommendedMedication = (country?: Country) => {
  const mutation = country === "CH" ? chDeleteRecommendedMedication : deDeleteRecommendedMedication

  const [commit] = useMutationWithErrorToast<
    chDeleteRecommendedMedicationMutation | deDeleteRecommendedMedicationMutation
  >(mutation)

  return useCallback(
    (params: MutationParams) => {
      const { id, progressNoteId, onCompleted, onError } = params
      const connection = ConnectionHandler.getConnectionID(
        progressNoteId,
        country === "CH"
          ? "ProgressNoteConnection_ch_recommendedMedications"
          : "ProgressNoteConnection_de_recommendedMedications",
      )
      commit({
        variables: { input: { id }, connections: [connection] },
        onCompleted,
        onError,
      })
    },
    [commit, country],
  )
}
